import gsap from 'gsap'

import Emitter from './Emitter'

class GlobalRaf {
  constructor() {
    this.init()
  }

  init() {
    this.on()
  }

  tick = (time, deltaTime) => {
    Emitter.emit('tick', { time, deltaTime })
  }

  on() {
    gsap.ticker.fps(-1)
    gsap.ticker.add(this.tick)
  }
}

export default new GlobalRaf()